import { IInstallGuideMenuProps } from "../../installGuideMenu/IInstallGuideMenuProps";
import { MenuItem } from "@snpjs/core";
import { Message } from "../../../../services/Message";
import { texts } from "../../../../i18n/texts";
import useTranslation from "../../../../hooks/useTranslation";

export const InstallGuideMenuItem: React.FC<IInstallGuideMenuProps> = (
  props
) => {
  const { t } = useTranslation();

  const onCopyToClipboard = () => {
    const link =
      window.location.origin +
      "/install-checklist/" +
      props.objectId +
      "/" +
      props.checksumSha1;

    navigator.clipboard.writeText(link);
    Message.info(t(texts.installChecklist.copyToClipboardDone));
  };

  return (
    <>
      <MenuItem
        icon="copy"
        text={t(texts.installChecklist.copyToClipboardButton)}
        onClick={onCopyToClipboard}
      />
    </>
  );
};
